/* Kocktail PDP — "Buy as" Single / Build-your-own bundle.

   In SINGLE mode the normal form submit runs (kocktail-cart-add.js adds the
   product and opens the cart drawer). In BUNDLE mode this script takes over the
   same "Add to basket" button: it enforces the bundle size + stock, then adds
   the picked bottles in one /cart/add.js request and (optionally) auto-applies a
   discount code before landing on the cart.

   It shares the button, so it intercepts submit in the CAPTURE phase and stops
   propagation in bundle mode — which prevents cart-add.js from also firing. */
(function () {
  /* Same route source as kocktail-cart-add.js, so a locale- or market-prefixed
     storefront posts to the prefixed URL. cart_add_url already ends in `.js`. */
  var ROUTES = (typeof Theme !== 'undefined' && Theme.routes) || {};
  var ADD_URL = ROUTES.cart_add_url || '/cart/add.js';

  /* Add one line per request, in order.
     Apps that decorate a line as it is added — pre-order, subscriptions,
     bundling — hook /cart/add.js and read the SINGLE-item shape, {id,
     quantity, properties}. Sending three bottles as one {items:[...]} request
     is a shape many of them only half-understand: the first entry gets
     processed and the rest go past untouched, which is exactly what a bundle
     of three coming back with one pre-order line looks like.
     Three requests instead of one costs two round trips on a deliberate,
     once-per-order action, and makes every bottle a first-class add. */
  function kxAddSequentially(list) {
    return list.reduce(function (chain, item) {
      return chain.then(function () {
        return fetch(ADD_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(item)
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw e; });
          return r.json();
        });
      });
    }, Promise.resolve());
  }

  var CART_URL = ROUTES.cart_url || '/cart';

  function money(cents) { return '£' + (cents / 100).toFixed(2); }

  function initPDP(form) {
    var picker = form.querySelector('[data-kx-bundle]');
    var addBtn = form.querySelector('[data-kx-addbtn]');
    var addLabel = form.querySelector('[data-kx-addlabel]');
    var modeRadios = form.querySelectorAll('[data-kx-mode-radio]');
    if (!picker || !addBtn || !modeRadios.length) return; // no bundle on this product

    var singleLabelHTML = addLabel ? addLabel.innerHTML : 'Add to basket';

    var size = parseInt(picker.dataset.size, 10) || 3;
    var lowAt = parseInt(picker.dataset.lowstock, 10) || 5;
    var bundleCents = picker.dataset.price ? parseInt(picker.dataset.price, 10) : null;
    var returnUrl = picker.dataset.return || CART_URL;
    var bundleLabel = picker.dataset.label || '';
    var discountCode = picker.dataset.discount || '';
    // The property name is set on the section; the value is each product's own
    // custom.pdp_ship_note, rendered onto its row.
    var shipProp = picker.dataset.shipProp || '';

    function shipFor(vid) {
      var row = picker.querySelector('[data-kx-row][data-vid="' + vid + '"]');
      return (row && row.getAttribute('data-ship')) || '';
    }

    var rows = Array.prototype.slice.call(picker.querySelectorAll('[data-kx-row]'));
    var pips = picker.querySelectorAll('[data-kx-pips] .kx-bb__pip');
    var pickedEl = picker.querySelector('[data-kx-picked]');
    var countEl = pickedEl ? pickedEl.closest('.kx-bb__count') : null;
    var statusEl = picker.querySelector('[data-kx-status]');
    var saveEl = picker.querySelector('[data-kx-save]');
    var errEl = picker.querySelector('[data-kx-err]');

    var picks = {}; // vid -> qty

    // Initial stock labels
    rows.forEach(function (row) {
      var stock = parseInt(row.dataset.stock, 10);
      var avail = row.dataset.avail === 'true';
      var wrap = row.querySelector('[data-kx-stock]');
      var label = row.querySelector('[data-kx-stock-label]');
      if (!wrap || !label) return;
      if (!avail || stock <= 0) {
        wrap.classList.add('is-out');
        label.textContent = 'Sold out';
        var a = row.querySelector('[data-kx-add]'); if (a) a.disabled = true;
      } else if (stock < 9999 && stock <= lowAt) {
        wrap.classList.add('is-low');
        label.textContent = 'Low stock · ' + stock + ' left';
      } else {
        label.textContent = 'In stock';
      }
    });

    function totalPicked() {
      return Object.keys(picks).reduce(function (s, k) { return s + picks[k]; }, 0);
    }

    function isBundle() { return form.dataset.kxMode === 'bundle'; }

    function renderButton() {
      if (isBundle()) {
        var picked = totalPicked();
        var ready = picked === size;
        addBtn.disabled = !ready;
        if (addLabel) {
          addLabel.textContent = ready
            ? 'Add to basket'
            : 'Pick ' + (size - picked) + ' more →';
        }
      } else {
        addBtn.disabled = false;
        if (addLabel) addLabel.innerHTML = singleLabelHTML;
      }
    }

    function renderPicker() {
      var picked = totalPicked();
      var remaining = size - picked;

      if (pickedEl) pickedEl.textContent = picked;
      if (countEl) countEl.classList.toggle('is-full', picked === size);
      pips.forEach(function (p, i) { p.classList.toggle('is-on', i < picked); });

      if (statusEl) {
        if (remaining <= 0) {
          statusEl.textContent = 'Bundle ready ✓';
          statusEl.classList.add('is-ready');
        } else {
          statusEl.textContent = 'Add ' + remaining + ' more flavour' + (remaining > 1 ? 's' : '');
          statusEl.classList.remove('is-ready');
        }
      }

      if (bundleCents != null && saveEl) {
        var listTotal = rows.reduce(function (s, row) {
          var q = picks[row.dataset.vid] || 0;
          return s + q * parseInt(row.dataset.price, 10);
        }, 0);
        var save = listTotal - bundleCents;
        saveEl.textContent = picked === size && save > 0 ? '· save ' + money(save) : '';
      }

      rows.forEach(function (row) {
        var vid = row.dataset.vid;
        var stock = parseInt(row.dataset.stock, 10);
        var avail = row.dataset.avail === 'true';
        var qty = picks[vid] || 0;
        var stepper = row.querySelector('[data-kx-stepper]');
        var addBtnRow = row.querySelector('[data-kx-add]');
        var qtyEl = row.querySelector('[data-kx-qty]');
        var up = row.querySelector('[data-kx-up]');
        if (qtyEl) qtyEl.textContent = qty;
        if (qty > 0) {
          if (stepper) stepper.hidden = false;
          if (addBtnRow) addBtnRow.hidden = true;
          if (up) up.disabled = remaining <= 0 || qty >= stock;
        } else {
          if (stepper) stepper.hidden = true;
          if (addBtnRow) { addBtnRow.hidden = false; addBtnRow.disabled = !avail || stock <= 0 || remaining <= 0; }
        }
      });

      renderButton();
    }

    function setQty(vid, q) {
      if (q <= 0) delete picks[vid]; else picks[vid] = q;
      renderPicker();
    }

    rows.forEach(function (row) {
      var vid = row.dataset.vid;
      var stock = parseInt(row.dataset.stock, 10);
      var add = row.querySelector('[data-kx-add]');
      var up = row.querySelector('[data-kx-up]');
      var dn = row.querySelector('[data-kx-dn]');
      if (add) add.addEventListener('click', function () { if (totalPicked() < size) setQty(vid, 1); });
      if (up) up.addEventListener('click', function () {
        var q = picks[vid] || 0;
        if (totalPicked() < size && q < stock) setQty(vid, q + 1);
      });
      if (dn) dn.addEventListener('click', function () { setQty(vid, (picks[vid] || 0) - 1); });
    });

    // The headline price follows the chosen mode. With "Buy 3" beside "Build
    // your own 3", a page still showing one bottle's price reads as three
    // glasses for the price of one. Each radio carries its own total, rendered
    // by Liquid, so nothing is calculated here and currency formatting stays
    // Shopify's. The mobile sticky bar mirrors this element already.
    var priceEl = form.closest('.kx-pdp, [id^="shopify-section"]');
    priceEl = priceEl && priceEl.querySelector('[data-kx-price]');

    var unitEl = form.closest('.kx-pdp, [id^="shopify-section"]');
    unitEl = unitEl && unitEl.querySelector('[data-kx-unit]');

    function syncPrice(radio) {
      if (!radio) return;
      var p = radio.getAttribute('data-kx-mode-price');
      if (priceEl && p) priceEl.textContent = p;
      // The per-unit figure follows the option too: three of one bottle and a
      // mixed three can be priced differently, so a unit figure left behind
      // would be quoting the option the shopper just moved away from.
      var u = radio.getAttribute('data-kx-mode-unit');
      if (unitEl && u) unitEl.textContent = u;
    }

    // Mode toggle
    function setMode(mode) {
      form.dataset.kxMode = mode;
      picker.hidden = mode !== 'bundle';
      if (mode === 'bundle') renderPicker(); else renderButton();
    }
    modeRadios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        setMode(r.dataset.kxModeRadio);
        syncPrice(r);
      });
    });

    // Intercept submit in capture phase; own it only in bundle mode.
    form.addEventListener('submit', function (e) {
      if (!isBundle()) return; // single mode → let kocktail-cart-add.js handle it
      e.preventDefault();
      e.stopImmediatePropagation();
      if (totalPicked() !== size) return;

      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
      addBtn.disabled = true;
      if (addLabel) addLabel.textContent = 'Adding…';

      var groupId = 'kx-' + Date.now();
      // A fresh properties object per line, not one shared between them. Each
      // bottle carries its own dispatch note — a mixed bundle can hold one
      // that ships now and one that does not — so a single object would put
      // the last bottle's date on all three.
      var items = Object.keys(picks).map(function (vid) {
        var it = { id: parseInt(vid, 10), quantity: picks[vid] };
        var props = {};
        if (bundleLabel) {
          props.Bundle = bundleLabel;
          props._kx_bundle = groupId;
        }
        var ship = shipFor(vid);
        if (shipProp && ship) props[shipProp] = ship;
        if (Object.keys(props).length) it.properties = props;
        return it;
      });

      // Optional gift-box add-on
      var giftLabel = form.querySelector('[data-kx-gift-variant]');
      if (giftLabel) {
        var giftCheck = giftLabel.querySelector('input[type="checkbox"]');
        if (giftCheck && giftCheck.checked) items.push({ id: parseInt(giftLabel.getAttribute('data-kx-gift-variant'), 10), quantity: 1 });
      }

      // Preferred path: add the bottles and open the cart drawer in place (no
      // navigation), matching the design. A discount CODE still needs a redirect
      // to be applied; an *automatic* discount needs neither (leave discountCode
      // empty for that). Falls back to a plain add + navigation if the shared
      // cart helper isn't available.
      var canDrawer = window.KocktailCart && window.KocktailCart.usable && !discountCode;
      if (canDrawer) {
        // Wait for the add before touching the picker. Clearing it up-front
        // left the button enabled but labelled "Pick 3 more", which does
        // nothing when clicked because the handler needs a full bundle: the
        // basket looked ready to take another bundle and would not.
        // renderPicker() re-derives every control from `picks`, so it is the
        // reset — never set addBtn.disabled by hand alongside it.
        window.KocktailCart.add(items).then(function (ok) {
          if (ok) {
            picks = {};
          } else if (errEl) {
            errEl.hidden = false;
            errEl.textContent = 'Sorry, something went wrong. Please try again.';
          }
          renderPicker();
        });
        return;
      }

      kxAddSequentially(items)
        .then(function () {
          if (discountCode) {
            window.location = '/discount/' + encodeURIComponent(discountCode) + '?redirect=' + encodeURIComponent(returnUrl || '/cart');
          } else {
            window.location = returnUrl;
          }
        })
        .catch(function (er) {
          addBtn.disabled = false;
          renderButton();
          if (errEl) { errEl.hidden = false; errEl.textContent = (er && er.description) ? er.description : 'Sorry — something went wrong. Please try again.'; }
        });
    }, true);

    renderButton();

    // Coming back from the cart with the browser's back button restores the
    // page from the back/forward cache exactly as it was left: mid-submit,
    // with the button disabled and still reading "Adding...". Re-derive the
    // controls on restore so the picker is usable again.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) { if (isBundle()) renderPicker(); else renderButton(); }
    });
  }

  function init() {
    document.querySelectorAll('form[data-kx-cart-form]').forEach(initPDP);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
